<template>
  <el-row v-for="assort in assorts" :key="assort.id" :gutter="20" class="addon-product-item-vertical" justify="center" align="middle"
    style="border-bottom: 1px solid #ccc; padding-bottom: 16px;" @click="handleQuickView">
    <el-col :xs="15" :sm="19">
      <div class="grid-content ep-bg-purple-dark">
        <div class="text-title text-truncate-2">
          {{ dt(product.name_translations) }}
        </div>
        <div class="text-subtitle text-truncate-2 text-muted">
          {{ dt(assort.name_translations) }}
        </div>
        <el-tag v-if="dt(assort?.label_translations)" effect="dark" size="small" class="py-1" style="white-space: pre-wrap;height: auto;">
          {{ dt(assort.label_translations) }}
        </el-tag>
        <div v-if="assort.addon_price && !hiddenPrice" class="product-price mt-1">
          <span class="text-price text-accent">
            {{ aliasTranslations?.addon_price || t("products.addonPrice") }}
            
            {{ currencySymbol }}
            {{ n(assort.addon_price) }}
          </span>
        </div>
        <el-button type="primary" plain class="mt-1 hidden-2xs" @click.stop="handleQuickAddToCart">
          <i class="fa fa-cart-plus mr-2" aria-hidden="true"></i>
          加購
        </el-button>
        <!-- <div v-if="product?.price_range" class="product-price">
          <span class="text-price text-accent">
            {{ t("products.addonPrice") }}
            {{ priceRange(product.price_range, "addon_price") }}
          </span>
          <template v-if="displayCoinReward">
            <br>
            <span class="text-warning">
              <img src="/static/images/coin.png" style="max-height: 30px" alt="owner_coin_reward">
              {{ priceRange(product.price_range, "owner_coin_reward", "", true) }}
            </span>
          </template>
        </div> -->
      </div>
    </el-col>
    <el-col :xs="9" :sm="5">
      <div>
        <el-image :src="imgProxy(assort?.image_url || product?.image_url, rs = 'fill:250:250:1')"
          :alt="dt(product?.name_translations)" style="width: 100%; max-width: 250px" :style="imageStyle">
          <template #error>
            <img src="/static/assets/front-end/img/image-place-holder.png" :alt="dt(product?.name_translations)"
              style="width: 100%;">
          </template>
        </el-image>
        <el-button size="large" class="btn-addon-to-cart-fab" circle @click.stop="handleQuickAddToCart">
          <template #icon>
            <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
          </template>
        </el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, priceRange, imgProxy, lookupAliasTranslations } from "../../utils"

const props = defineProps({
  product: Object,
  currencySymbol: String,
  itemLayout: { type: String, default: "vertical" },
  storeData: Object,
})
const emit = defineEmits(['ok', 'show'])

const { t, n, locale } = useI18n()

const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

// const displayCoinReward = computed(() => props.product?.display_coin_reward && props.product?.price_range?.min_owner_coin_reward > 0)
const currency = computed(() => aibTrackers?.currency)
const assorts = computed(() => {
  const list = []
  if (props.product?.assorts !== undefined && props.product?.assorts.length > 0 ) {
    props.product?.assorts.forEach((assort) => {
      assort.addon_price = assort?.addon_price_currencies?.[currency.value]
      if (assort.addon_price) {
        list.push(assort)
      }
    })
  }
  return list
})

const contentStyle = computed(() => {
  if (props.itemLayout == "horizontal") {
    return {
      borderRadius: '0px 5px 5px 0px',
    }
  }
  return {
    // minHeight: displayCoinReward.value ? '180px' : '150px',
    // paddingTop: '10px',
    borderRadius: '0px 0px 5px 5px',
  }
})
const imageStyle = computed(() => {
  if (props.itemLayout == "horizontal") {
    return {
      borderRadius: '5px 0px 0px 5px',
    }
  }
  return {
    borderRadius: '5px 5px 0px 0px',
  }
})

const currencyMap = (currency = "TWD") => {
  const currency_map = {
    "USD": { "symbol": "US$", "point": 2 },
    "TWD": { "symbol": "NT$", "point": 0 },
    "CNY": { "symbol": "¥", "point": 1 },
  }

  if (currency_map?.[currency]) {
    return currency_map[currency]
  }

  return currency
}

const handleQuickAddToCart = async (item) => {
  emit("ok", props.product)
}

const handleQuickView = async () => {
  emit("show", props.product)
}
</script>

<style lang="scss">
.addon-product-item-vertical {

  .btn-addon-plus {
    position: absolute;
    z-index: 1;
    right: 0.2rem;
    bottom: 0.6rem;
    width: 2.5rem;
    height: 2.5rem;
    background: rgb(255 255 255 / 60%);
  }

  .text-title {
    font-size: 1rem !important;
    line-height: 1.2rem !important;
    font-weight: 600 !important;
    margin-bottom: 0.25rem !important;
  }

  .text-subtitle {
    font-size: 0.875rem !important;
    line-height: 1rem !important;
    font-weight: 500 !important;
  }

  .text-price {
    font-size: 1rem !important;
    line-height: 1.2rem !important;
    font-weight: 600 !important;
  }

  .btn-addon-to-cart-fab {
    background-color: rgba(255, 255, 255, 0.7);
    position: absolute;
    bottom: 10px;
    right: 14px;
    border-color: var(--color);
  }
}
</style>
